@if (displayShippingInfo()) {
  <app-shipping-info></app-shipping-info>
}
@if (displayAnnouncements()) {
  <app-announcements></app-announcements>
}
